import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import GoogleConnectButton from '../../../Google/GoogleConnectButton';
import GoogleDisconnectButton from '../../../Google/GoogleDisconnectButton';
import GoogleSettings from '../../../Google/GoogleSettings';

const SettingsTabGoogle = ({ googleAccount, setGoogleAccount, handleChange, connectButton, merchantCenter }) => {
  return googleAccount && !googleAccount.refreshTokenRevoked ? (
    <>
      {googleAccount.adAccountDisabled && (
        <Alert variant="light" color="red" title="Google Ads account disabled" icon={<IconAlertTriangle size={16} />} mb="md">
          The connected Google Ads account has been deactivated or suspended. Please select a different ad account below to restore functionality.
        </Alert>
      )}
      <GoogleSettings
        googleAccount={googleAccount}
        handleChange={handleChange}
        connectButton={connectButton}
        merchantCenter={merchantCenter}
      />
      <GoogleDisconnectButton setGoogleAccount={setGoogleAccount} />
    </>
  ) : (
    <GoogleConnectButton />
  );
};

export default SettingsTabGoogle;
